import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';

import {VisualizationType} from '../AnalyticsVisualizationTypes';
import Continuous2DChartConfigEditor from './config-components/Continuous2DChartConfigEditor';
import FormatConfigEditor from './config-components/FormatConfigEditor';
import XYSeriesColumnEditor from './config-components/XYSeriesColumnEditor';
import TabbedConfigEditorSkeleton from './TabbedConfigEditorSkeleton';
import {VisualizationConfigEditorComponentProps} from './VisualizationConfigEditorTypes';

type LineChartParameters = ExtractByTypename<
  AnalyticsVisualization['parameters'],
  'AnalyticsVisualizationLineChartParametersNode'
>;

export type LineChartConfigEditorProps = VisualizationConfigEditorComponentProps<LineChartParameters>;

export default function LineChartConfigEditor(props: LineChartConfigEditorProps): JSX.Element {
  const {visualizationConfig, enableFormatTab} = props;

  if (enableFormatTab) {
    return (
      <TabbedConfigEditorSkeleton
        setupTabContent={
          <>
            <XYSeriesColumnEditor {...props} />
          </>
        }
        formatTabContent={
          <>
            <FormatConfigEditor {...props} />
          </>
        }
        enableAnalysisTab={false}
        visualizationConfigId={visualizationConfig.id}
        visualizationType={VisualizationType.LINE_CHART}
      />
    );
  }

  return (
    <>
      <XYSeriesColumnEditor {...props} />
      <Continuous2DChartConfigEditor {...props} />
    </>
  );
}
